<template>

<section class="container my-2">
<div class="board shadow">
  <h3>Alerts</h3>
  <p class="display-8">Provide contextual feedback messages for typical user actions with a handful of available and flexible alert messages.</p>
  <p>Alerts are available for any length of text, as well as an optional dismiss button. Alerts can also contain additional HTML elements like title, paragraphs, links, and dividers.</p>

  <br><hr>

  <p class='bold'>● Alerts - rendered with icons by default, depending on type of alert (color scheme) </p>

  <sym-alert class="primary-light">
    <span>This is an alert with 'primary-light' color</span>
  </sym-alert>

  <sym-alert class="info-light">
    <span>This is an alert with 'info-light' color</span>
  </sym-alert>

  <sym-alert class="success-light">
    <span>This is an alert with 'success-light' color</span>
  </sym-alert>

  <sym-alert class="warning-light">
    <span>This is an alert with 'warning-light' color</span>
  </sym-alert>

  <sym-alert class="danger-light">
    <span>This is an alert with 'danger-light' color</span>
  </sym-alert>

  <sym-alert class="dark-light">
    <span>This is an alert with 'dark-light' color</span>
  </sym-alert>

  <sym-alert class="primary">
    <span>This is an alert with 'primary' color</span>
  </sym-alert>

  <sym-alert class="info">
    <span>This is an alert with 'info' color</span>
  </sym-alert>

  <sym-alert class="success">
    <span>This is an alert with 'success' color</span>
  </sym-alert>

  <sym-alert class="warning">
    <span>This is an alert with 'warning' color</span>
  </sym-alert>

  <sym-alert class="danger">
    <span>This is an alert with 'danger' color</span>
  </sym-alert>

  <sym-alert class="dark">
    <span>This is an alert with 'dark' color</span>
  </sym-alert>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="49">
  <sym-alert class="primary-light">
    <span>This is an alert with 'primary-light' color</span>
  </sym-alert>

  <sym-alert class="info-light">
    <span>This is an alert with 'info-light' color</span>
  </sym-alert>

  <sym-alert class="success-light">
    <span>This is an alert with 'success-light' color</span>
  </sym-alert>

  <sym-alert class="warning-light">
    <span>This is an alert with 'warning-light' color</span>
  </sym-alert>

  <sym-alert class="danger-light">
    <span>This is an alert with 'danger-light' color</span>
  </sym-alert>

  <sym-alert class="dark-light">
    <span>This is an alert with 'dark-light' color</span>
  </sym-alert>

  <sym-alert class="primary">
    <span>This is an alert with 'primary' color</span>
  </sym-alert>

  <sym-alert class="info">
    <span>This is an alert with 'info' color</span>
  </sym-alert>

  <sym-alert class="success">
    <span>This is an alert with 'success' color</span>
  </sym-alert>

  <sym-alert class="warning">
    <span>This is an alert with 'warning' color</span>
  </sym-alert>

  <sym-alert class="danger">
    <span>This is an alert with 'danger' color</span>
  </sym-alert>

  <sym-alert class="dark">
    <span>This is an alert with 'dark' color</span>
  </sym-alert>
  </textarea>

  <br><hr>

  <p class='bold'>● Alerts - with attribute 'dismissible'</p>
  <div class="buttons" primary-light>
    <button @click="showDismissed()">Show dismissed alerts</button>
    <button @click="dismissAll()">Dismiss all</button>
  </div>

  <br><br>

  <sym-alert class="info-light" dismissible ref="alert-info">
    <span>This is a dismissible alert with 'info-light' color</span>
  </sym-alert>

  <sym-alert class="success-light" dismissible ref="alert-success">
    <span>This is a dismissible alert with 'success-light' color</span>
  </sym-alert>

  <sym-alert class="warning-light" dismissible ref="alert-warning">
    <span>This is a dismissible alert with 'warning-light' color</span>
  </sym-alert>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="13">
  <sym-alert class="info-light" dismissible>
    <span>This is a dismissible alert with 'info-light' color</span>
  </sym-alert>

  <sym-alert class="success-light" dismissible>
    <span>This is a dismissible alert with 'success-light' color</span>
  </sym-alert>

  <sym-alert class="warning-light" dismissible>
    <span>This is a dismissible alert with 'warning-light' color</span>
  </sym-alert>
  </textarea>

  <br><hr>

  <p class='bold'>● Alerts - without icons</p>

  <sym-alert class="info-light" icon="none">
    <span>This is an alert with 'info-light' color and no default icon</span>
  </sym-alert>

  <sym-alert class="success-light" icon="none">
    <span>This is an alert with 'success-light' color and no default icon</span>
  </sym-alert>

  <sym-alert class="warning-light" icon="none">
    <span>This is an alert with 'warning-light' color and no default icon</span>
  </sym-alert>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="13">
  <sym-alert class="info-light" icon="none">
    <span>This is an alert with 'info-light' color and no default icon</span>
  </sym-alert>

  <sym-alert class="success-light" icon="none">
    <span>This is an alert with 'success-light' color and no default icon</span>
  </sym-alert>

  <sym-alert class="warning-light" icon="none">
    <span>This is an alert with 'warning-light' color and no default icon</span>
  </sym-alert>
  </textarea>

  <br><hr>

  <p class='bold'>● Alert with title, divider, custom icon and a link</p>

  <sym-alert class="info-light" title="Quote of the Day" icon="quote-left">
    <hr>
    <p class="mb-0">The journey of a thousand miles begins with one step. --
    <a href="https://en.wikipedia.org/wiki/Laozi" class="alert-link sm-1">Lao Tze</a>
    </p>
  </sym-alert>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="8">
  <sym-alert class="info-light" title="Quote of the Day" icon="quote-left">
    <hr>
    <p class="mb-0">The journey of a thousand miles begins with one step.
    <a href="https://en.wikipedia.org/wiki/Laozi" class="quote-footer alert-link sm-1">Lao Tze</a>
    </p>
  </sym-alert>
  </textarea>

  <br><hr>

  <p class='bold'>● Alerts - auto-dismissed after set duration</p>

  <button class="danger-light mb-3 shadow-light" @click="addAutoDismissAlert()">Add auto-dismissed alert</button>

  <sym-alert class="info-light" v-for="(alert, index) in alerts" :duration="duration" :key="alert.key" @dismissed="alerts.splice(index, 1)">
    <span>This alert will auto-dismiss after <b>3 seconds</b></span>
  </sym-alert>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="34">
  <template>
  <section>
    <button class="danger-light mb-3 shadow-light" @click="addAutoDismissAlert()">Add auto-dismissed alert</button>

    <sym-alert
      class="info-light"
      v-for="(alert, index) in alerts"
      :duration="duration"
      :key="alert.key"
      @dismissed="alerts.splice(index, 1)"
    >
      <span>This alert will auto-dismiss after <b>3 seconds</b></span>
    </sym-alert>
  </section>
  </template>

  <script>
  export default {
    data () {
      return {
        alerts: [],
        duration: 3
      };
    },

    methods: {
      addAutoDismissAlert () {
        this.alerts.push({key: new Date().getTime()});
      }
    }
  }
  </script>
  </textarea>

  <br><hr>

  <p class='bold'>● Alert - used with Collapse</p>

  <button class="danger-light mb-3 shadow-light" @click="toggleAlertVisibility()">Toggle alert</button>

  <sym-collapse v-model="alertToggle">
    <sym-alert class="success-light" ref="alert-toggle" dismissible @dismissed="alertToggle=false">This alert <b>will toggle on dismiss/button click</b>.
    </sym-alert>
  </sym-collapse>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="32">
  <template>
  <section>
    <button class="danger-light mb-3 shadow-light" @click="toggleAlertVisibility()">Toggle alert</button>

    <sym-collapse v-model="alertToggle">
      <sym-alert class="success-light" ref="alert-toggle" dismissible @dismissed="alertToggle=false">This alert
        <b>will toggle on dismiss/button click</b>.
      </sym-alert>
    </sym-collapse>
  </section>
  </template>

  <script>
  export default {
    data () {
      return {
        alertToggle: true
      };
    },

    methods: {
      toggleAlertVisibility () {
        this.alertToggle = !this.alertToggle;
        if (this.alertToggle) {
          this.$refs['alert-toggle'].isVisible = true;
        }
      }
    }
  }
  </script>
  </textarea>

</div>

</section>

</template>

<script>

import PageBase from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'samples-alert',

  data () {
    return {
      alerts: [],
      duration: 3,
      alertToggle: true
    };
  },

  methods: {
    showDismissed () {
      this.setVisibility('info', true);
      this.setVisibility('success', true);
      this.setVisibility('warning', true);
    },

    dismissAll () {
      this.setVisibility('info', false);
      this.setVisibility('success', false);
      this.setVisibility('warning', false);
    },

    setVisibility (refId, flag) {
      this.$refs['alert-' + refId].isVisible = flag;
    },

    addAutoDismissAlert () {
      this.alerts.push({key: new Date().getTime()});
    },

    toggleAlertVisibility () {
      this.alertToggle = !this.alertToggle;
      if (this.alertToggle) {
        this.$refs['alert-toggle'].isVisible = true;
      }
    }
  }
}

</script>
